import React, { Component } from 'react';

import ErrorBoundary from 'components/ErrorBoundary';

import TimeCard from 'components/TimeCard';
import CameraCard from 'components/CameraCard';
import SupportCard from 'components/SupportCard';
import DepartureCard from 'components/Departure/Card';
import SchoolmealCard from 'components/Schoolmeal/Card';

// import CampaignDigitalOcean from 'components/Campaign/DigitalOcean';

import schoolLogo from '../media/ntig-white.svg';
import poweredByDoBadge from '../media/brands/digitalocean/Powered_by_Badge_white.svg';
// import builtWithFirebaseBadge from '../media/brands/firebase/logo-built_white.svg';
// import builtWithFirebaseBadge from '../media/brands/firebase/logo-knockout.svg';

class App extends Component {
  render() {
    return (
      <main className='App'>
        <div className='Grid'>
          <div className='Grid__col'>
            <ErrorBoundary>
              <DepartureCard stopSlug='chalmers-goteborg' />
            </ErrorBoundary>
          </div>
          <div className='Grid__col'>
            <ErrorBoundary>
              <DepartureCard stopSlug='kapellplatsen-goteborg' />
            </ErrorBoundary>
          </div>
          <div className='Grid__col'>
            <ErrorBoundary>
              <DepartureCard stopSlug='chalmers-tvargata-goteborg' />
            </ErrorBoundary>

            <ErrorBoundary>
              <DepartureCard stopSlug='chalmersplatsen-goteborg' />
            </ErrorBoundary>

            <ErrorBoundary
              style={{
                display: 'none',
              }}
            >
              <CameraCard cameraId='17' />
            </ErrorBoundary>
          </div>
          <div className='Grid__col'>
            <ErrorBoundary>
              <TimeCard />
            </ErrorBoundary>

            <ErrorBoundary>
              <SchoolmealCard schoolSlug='it-gymnasiet-goteborg' />
            </ErrorBoundary>

            <ErrorBoundary>
              <SupportCard contactEmail='support@ntinfo.se' />
            </ErrorBoundary>

            {/* <CampaignDigitalOcean /> */}
          </div>
        </div>

        <footer className='App__footer'>
          <img
            alt='NTI Gymnasiet'
            src={schoolLogo}
            draggable={false}
            style={{
              position: 'fixed',
              bottom: '15px',
              left: '15px',
              width: '175px',
            }}
          />

          <a
            href='https://nti.page.link/do'
            target='_blank'
            rel='noopener noreferrer'
          >
            <img
              alt='Powered by DigitalOcean'
              src={poweredByDoBadge}
              draggable={undefined}
              style={{
                position: 'fixed',
                bottom: '15px',
                right: '15px',
                width: '175px',
              }}
            />
          </a>
          {/* <a
            href='https://nti.page.link/do'
            target='_blank'
            rel='noopener noreferrer'
          >
            <img
              alt='Built with Firebase'
              src={builtWithFirebaseBadge}
              draggable={false}
              style={{
                position: 'fixed',
                bottom: '15px',
                right: '220px',
                width: '150px',
              }}
            />
          </a> */}
        </footer>
      </main>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.jsx